<template>
  <div>
    <el-dialog
      :title="configSortData.title"
      :visible.sync="configSortData.show"
      center
    >
      <div class="game-box">
        <el-table
          row-key="type"
          id="sortTable"
          :data="tableData"
          border
          :cell-style="{ padding: '1' }"
        >
          <el-table-column
            align="center"
            width="100px"
            prop="title"
            :label="$t('Game')"
          ></el-table-column>
          <el-table-column align="center" :label="$t('IsHomePage')">
            <template slot-scope="scope">
              <el-switch
                v-model="scope.row.ishomeStatus"
                :width="35"
               :inactive-text="$t('No')"
                :active-text="$t('Yes')"
                @change="$forceUpdate()"
                style="margin-right: 5px"
              >
              </el-switch>
            </template>
          </el-table-column>
          <el-table-column align="center" :label="$t('IsPopular')">
            <template slot-scope="scope">
              <el-switch
                v-model="scope.row.ishotStatus"
                :width="35"
               :inactive-text="$t('No')"
                :active-text="$t('Yes')"
                @change="$forceUpdate()"
                style="margin-right: 5px"
              >
              </el-switch>
            </template>
          </el-table-column>
          <el-table-column align="center" :label="$t('IsLatest')">
            <template slot-scope="scope">
              <el-switch
                v-model="scope.row.isnewStatus"
                :width="35"
               :inactive-text="$t('No')"
                :active-text="$t('Yes')"
                @change="$forceUpdate()"
                style="margin-right: 5px"
              >
              </el-switch>
            </template>
          </el-table-column>
          <el-table-column align="center"  :label="$t('IsRecommended')">
            <template slot-scope="scope">
              <el-switch
                v-model="scope.row.isrecomStatus"
                :width="35"
               :inactive-text="$t('No')"
                :active-text="$t('Yes')"
                @change="$forceUpdate()"
                style="margin-right: 5px"
              >
              </el-switch>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="confirmSort">{{$t('Save')}}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import Sortable from "sortablejs";
export default {
  props: {
    configSortData: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      tableData: [],
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.initSort();
    });
  },
  created() {
    if (JSON.parse(this.configSortData.data.ConfigValue)) {
      this.tableData = JSON.parse(this.configSortData.data.ConfigValue);
      this.tableData.forEach((item) => {
        item.ishomeStatus = item.ishome == 1 ? true : false;
        item.ishotStatus = item.ishot == 1 ? true : false;
        item.isnewStatus = item.isnew == 1 ? true : false;
        item.isrecomStatus = item.isrecom == 1 ? true : false;
      });
    }
  },
  methods: {
    initSort() {
      const el = document.querySelector(
        "#sortTable .el-table__body-wrapper > table > tbody"
      );
      new Sortable(el, {
        onEnd: (evt) => {
          const currRow = this.tableData.splice(evt.oldIndex, 1)[0];
          this.tableData.splice(evt.newIndex, 0, currRow);
        },
      });
    },
    confirmSort() {
      let arr = this.tableData.map((item) => {
        return {
          ishome: item.ishomeStatus ? 1 : 2,
          ishot: item.ishotStatus ? 1 : 2,
          isnew: item.isnewStatus ? 1 : 2,
          isrecom: item.isrecomStatus ? 1 : 2,
          state: item.state,
          title: item.title,
          type: item.type,
        };
      });
      this.configSortData.data.ConfigValue = JSON.stringify(arr);
      this.$emit("confirmSmallSortData", this.configSortData.data);
    },
  },
};
</script>

<style scoped>
.game-box {
  display: flex;
  overflow: auto;
  max-height: 610px;
}

.gameItem {
  margin-right: 20px;
  padding-bottom: 30px;
}

.gameItem:last-of-type {
  margin: 0;
}
</style>
